import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    roles: []
  },
  getters: {
    roles: state => state.roles
  },
  mutations: {
    roles(state, payload) {
      state.roles = payload
    }
  }
}
